import React from 'react';
import { Modal } from 'antd';

const ConfirmModal = ({
    visible,
    title = "Подтверждение",
    message = "Данные не будут сохранены. Продолжить?",
    okText = "Продолжить",
    cancelText = "Отмена",
    onConfirm,
    onCancel,
    type = "warning"
}) => {
    const handleOk = () => {
        onConfirm(true);
    };

    const handleCancel = () => {
        onCancel(false);
    };

    return (
        <Modal
            title={title}
            open={visible}
            onOk={handleOk}
            onCancel={handleCancel}
            okText={okText}
            cancelText={cancelText}
            okButtonProps={{
                danger: type === 'danger',
                type: type === 'danger' ? 'primary' : 'default'
            }}
        >
            <p>{message}</p>
        </Modal>
    );
};

export default ConfirmModal;